let challengeRequestHandler = null;

export const registerChallengeHandler = (handler) => {
  challengeRequestHandler = handler;
};

export const unregisterChallengeHandler = (handler) => {
  if (challengeRequestHandler === handler) {
    challengeRequestHandler = null;
  }
};

export const requestTurnstileToken = (params) => {
  if (typeof challengeRequestHandler !== 'function') {
    return Promise.reject(new Error('Turnstile challenge handler is not registered'));
  }
  return challengeRequestHandler(params);
};
